export const GET_PERMISIONS = 'GET_PERMISIONS';
export const GET_PERMISIONS_SUCCESS = 'GET_PERMISIONS_SUCCESS';
export const GET_PERMISIONS_ERROR = 'GET_PERMISIONS_ERROR';
